module.exports = __webpack_public_path__ + "img/buy-part.6f658e87.png";